import React from 'react';

import PropTypes from 'prop-types';

import { XSS_FILTER_OPTIONS, XSS_HARSH_FILTER_OPTIONS } from 'constants/Constants';

import { filterXSS } from 'xss';

export const LightDangerouslyHtml = ({ sanitizeAllHtmlTags = false, ...props }) => {
    const data = filterXSS(props.dangerouslyHtml, sanitizeAllHtmlTags ? XSS_HARSH_FILTER_OPTIONS : XSS_FILTER_OPTIONS);

    if (props.type === 'span') {
        return <span dangerouslySetInnerHTML={{ __html: data }} />;
    } else {
        return <div dangerouslySetInnerHTML={{ __html: data }} />;
    }
};

LightDangerouslyHtml.propTypes = {
    dangerouslyHtml: PropTypes.string,
    sanitizeAllHtmlTags: PropTypes.bool,
};
